import HelpCard from "../../Components/Footer/HelpCenterCard/HelpCard";
import FaqComponent from "../../Components/Footer/FaqComponent/FaqComponent";
import ServicesCardSection from "../ItPage/ServicesCardSection/ServicesCardSection";
import BgvStepsSection from "../ItPage/BgvStepsSection/BgvStepsSection";
import BgvServiceSection from "../ItPage/BgvServiceSection/BgvServiceSection";
import BrandCarousel from "../ItPage/BrandCarousel/BrandCarousel";
// import { useNavigate } from "react-router-dom";
import ButtonComponent from "../../Components/Buttons/ButtonComponent";
import { Helmet } from "react-helmet-async";

const digitalOceanURL =
  "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets";

const bg_image = `${digitalOceanURL}/About_Us_img/About_bg.png`;
const Game_Img = `${digitalOceanURL}/Sector/Games.png`;

export default function Games() {
  return (
    <>
      <Helmet>
        <title>
          Player Verification - Protecting Players and Preventing Fraud
        </title>
        <meta
          name="description"
          content="provides comprehensive player verification for online gaming, simplifying player onboarding, preventing fraud, and ensuring regulatory compliance with real-time checks. Secure your platform."
        />
        <meta
          name="keywords"
          content="game id verification, online gaming player verification, online gaming KYC, player verification, gaming onboarding solutions, fraud prevention gaming, gaming AML compliance,"
        />
        <meta
          property="og:title"
          content="Player Verification - Protecting Players and Preventing Fraud"
        />

        <meta name="robots" content="index, follow" />
        <meta
          property="og:description"
          content="provides comprehensive player verification for online gaming, simplifying player onboarding, preventing fraud, and ensuring regulatory compliance with real-time checks. Secure your platform."
        />
        <meta
          property="og:url"
          content="https://hirestar.io/industries/online-gaming"
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={Game_Img} />
        <meta property="og:image:type" content="image/png" />

        <link
          rel="canonical"
          href={`https://hirestar.io${window.location.pathname}`}
        />
        <meta property="og:site_name" content="Hirestar.io" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Player Verification - Protecting Players and Preventing Fraud"
        />
        <meta
          name="twitter:description"
          content="provides comprehensive player verification for online gaming, simplifying player onboarding, preventing fraud, and ensuring regulatory compliance with real-time checks. Secure your platform."
        />
        <meta name="twitter:image" content={Game_Img} />
        <meta property="og:locale" content="en_US" />
      </Helmet>
      <div className="relative  background_color ">
        {/* Image that is hidden on small screens */}
        <img
          src={bg_image}
          alt="game-img hero section"
          className="absolute  object-cover w-full lg:h-[150%] h-[110%] md:h-[120%] bg_curve_img"
        />

        <div className="mb-16 relative  w-full h-full md:top-28 lg:top-0">
          <div className="grid grid-cols-12 gap-4 justify-items-center relative top-0 lg:top-32 lg:mx-20 xl:mx-32 2xl:mx-40 items-center">
            {/* Text container */}
            <div className="col-span-12 md:col-span-12 lg:col-span-7 w-full Banking_heading font-semibold font-[poppins] top_spacing mx-2 lg:mx-0">
              <span className="industry_info">Game</span>
              <h1 className="w-full text-[32px] md:text-[40px] lg:text-[46px]">
                Reliable User Verification for Online Gaming Platforms
              </h1>
              <h2 className="about-text-para mt-2 ">
                Your trusted partner for handling high-volume user verification
                smoothly on gaming apps and websites.
              </h2>
              {/* Button Group */}
              <div className="mt-4">
                <ButtonComponent
                  arialLabel={
                    "Get in touch with an expert for Reliable User Verification for Online Gaming Platforms"
                  }
                />
              </div>
            </div>

            {/* Image container */}
            <div className="col-span-12 md:col-span-12 lg:col-span-5 relative   lg:mt-0 bottom_space mb-20 lg:mb-0">
              <img
                src={Game_Img}
                alt="about-girl img for games sector"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="lg:mt-[24rem] md:mt-[12rem] mt-[8rem]">
        <BrandCarousel />
      </div>
      {/* 3 section */}
      <BgvServiceSection Sector="Banking Sector" />
      {/* 4 section */}
      {/* <BgvStepsSection /> */}
      <ServicesCardSection Sector="Gaming Sector" Sector_cards="games" />
      <div className="mb-48">{<BgvStepsSection />}</div>
      <FaqComponent />
      <div className="relative top-28  left-0 right-0">
        <HelpCard />
      </div>
    </>
  );
}
